export default {
    PENDING: "PENDING",
    CANCELED: "CANCELED",
    SUCCESS: "SUCCESS",
    FAILURE: "FAILURE",
}